import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_SHOPKEEPER_INFORMATION_LIST } from "../../../Types";
import storage from "../../../apis/Storage";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const getWhitlistShopKeeperInformationList = (postedData) => async (dispatch) => {
  //debugger;
  dispatch(showLoading());
  await axios
    .post(`api/WhiteListing/GetWhitlistShopKeeperInformationList`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_SHOPKEEPER_INFORMATION_LIST,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const UpdateWhitlistShopKeeperInformation = (formValues) => async (dispatch) => {
  dispatch(showLoading());
  //debugger;
  await axios
    .post("api/WhiteListing/UpdateWhitlistShopKeeperInformation", formValues)
    .then(({ data }) => {
      dispatch(hideLoading());
      if (data) {
        if (data.isSuccess) {
          toast.success(
            "Whitlist ShopKeeper Information Updated successfully"
          );
        } else {
          toast.error(data.message);
        }
      }
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};


export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/WhiteListing/GetWhitlistShopKeeperInformationList`, requestData)
    .then(({ data }) => {
      const outputFilename = `ShopKeeper_Information_List_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distributor"
                ? "Distributor"
                : ws[address].v == "distCenter"
                ? "Dist Center"
                : ws[address].v == "vizId"
                ? "VIZ ID"
                : ws[address].v == "shopName"
                ? "Shop Name"
                : ws[address].v == "cnic"
                ? "CNIC No"
                : ws[address].v == "smobileNumber"
                ? "Mobile Number"
                : ws[address].v == "fullName"
                ? "Full Name"
                : ws[address].v == "email"
                ? "Email"
                : ws[address].v == "status"
                ? "WhiteListing Status"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.response.data, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};